import React from "react";
import PromoServices from "../services/PromoServices";
import { useState, useEffect } from "react";
import GlobalFunctions from "../services/GlobalFunctions";
import Carousel from "react-bootstrap/Carousel";
import GeneralMenu from "./GeneralUI/GeneralMenu";
import Swal from "sweetalert2";
import visitaWeb from "../Images/visitaWeb.jpg";

const Home = (params) => {
  const glob = new GlobalFunctions();
  const promoServices = new PromoServices();
  const [promos, setPromos] = useState([]);
  const [cargarPromos, setCargarPromos] = useState(true);

  useEffect(() => {
    promoServices.getPromos().then((data) => {
      if (cargarPromos) {
        setCargarPromos(false);
        setPromos(data);
      }
    });
  });

  function loadingImgCarousel() {
    document.getElementById("spanCargandoCarousel").style.display = "none";
  }

  function goProduct(id) {
    let href = "https://tucasabonita.site/product/" + id;
    window.open(
      href,
      "nuevo",
      "directories=no, location=no, menubar=no, scrollbars=yes, statusbar=no, tittlebar=no, width=800, height=600"
    );
  }

  function goCasabonita() {
    let href = process.env.REACT_APP_URL_CASA;
    window.open(
      href,
      "nuevo",
      "directories=no, location=no, menubar=no, scrollbars=yes, statusbar=no, tittlebar=no, width=800, height=600"
    );
  }

  return (
    <div style={{ marginTop: 3, textAlign: "center" }} className="container">
      <GeneralMenu
        goHome={params.goHome}
        validarGoMiCuenta={params.validarGoMiCuenta}
        goSolicitudes={params.goSolicitudes}
      ></GeneralMenu>
      <h1
        className="superTitulo"
        style={{ color: "black", textAlign: "center", fontSize: "1.5em" }}
      >
        Promociones tu casa bonita
      </h1>
      <span
        id="spanCargandoCarousel"
        className="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
      <Carousel variant="dark" indicators={false}>
        {promos.map((item, index) => {
          return (
            <Carousel.Item className="textAlignCenter" key={index}>
              <img
                onClick={() => goProduct(item.referencia)}
                onLoad={loadingImgCarousel}
                className={"cursorPointer " + params.thisWidth}
                src={process.env.REACT_APP_URL_CASA + item.imagen}
                alt=""
              />
              <h3 className="textAlignCenter fontSizeNormal">{item.nombre}</h3>
              <button
                type="button"
                onClick={() => goProduct(item.referencia)}
                style={{ backgroundColor: "green", marginTop: "0.5em" }}
                className="btn btn-success btn-md"
              >
                Comprar
              </button>
            </Carousel.Item>
          );
        })}
      </Carousel>
      <hr></hr>
      <div
        style={{ marginTop: "-0.5em", marginBottom: "-0.6em" }}
        className="card"
      >
        <img
          className="card-img-top centerImg"
          style={{ width: "30%", height: "auto", marginTop: "0.4em" }}
          src={window.location.href + "logo192.png"}
          alt="Card image cap"
        />
        <div className="card-body">
          <h2 className="card-title superTitulo">
            ¡Instala esta app para una mejor experiencia!
          </h2>
          <button
            onClick={params.handleInstallApp}
            style={{ marginTop: "0.4em" }}
            className="btn btn-primary"
          >
            <span style={{ display: "flex" }}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-arrow-down"
                viewBox="0 0 16 16"
                style={{ marginTop: "0.2em", marginRight: "0.3em" }}
              >
                <path
                  fillRule="evenodd"
                  d="M8 1a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L7.5 13.293V1.5A.5.5 0 0 1 8 1"
                />
              </svg>
              Instalar app
            </span>
          </button>
        </div>
      </div>
      <hr />
      <div
        style={{ textAlign: "center" }}
        className="col-lg-6 col-md-6 col-sm-12 col-12"
      >
        <h3 style={{marginTop: '0.5em'}} className="superTitulo">
          Recuerda que todos los productos de tu casa bonita también los puedes
          pagar a crédito!
        </h3>
        <br/>
        <img
          height="260"
          width="260"
          style={{
            cursor: "pointer",
            border: "border rounded",
            margin: "auto",
            display: "block",
          }}
          src={visitaWeb}
        ></img>
        <br></br>
        <a type="button" style={{ backgroundColor: "green" }} onClick={goCasabonita} className="btn btn-success">
          Ir a tucasabonita.site!
        </a>
        <br></br>
        <br></br>
      </div>
    </div>
  );
};

export default Home;
